module.exports = __webpack_public_path__ + "media/assets/images/languages/en-93394bccb9b738503b4cc101f950ca20.png";